<template>
    <v-layout row wrap v-if="affiliation">
        <v-flex xs12 md6>
            <!-- Affiliation Id -->
            <v-layout row wrap class="subheading pb-1">
                <v-flex xs6 class="grey--text text--darken-1">
                {{ $t("screener.affiliation.list.table.id") }}
                </v-flex>
                <v-flex xs6>
                {{ affiliation.id }}
                </v-flex>
            </v-layout>

            <!-- Affiliation Code -->
            <v-layout row wrap class="subheading justify-center align-center"  >
                <v-flex xs6 class="grey--text text--darken-1">{{
                $t("screener.affiliation.list.table.code")
                }}</v-flex>
                <v-flex xs6>
                {{ affiliation.code }}
                <v-tooltip slot="append" top color="white">
                    <v-btn
                    slot="activator"
                    small
                    icon
                    dark
                    @click="copyToClipboard(affiliation.code)"
                    >
                    <v-icon small color="primary">$vuetify.icons.rms_copy</v-icon>
                    </v-btn>
                    <span class="greyDarken3--text body-1">{{
                    $t("screener.monetization.coupon.code_copy.tooltip")
                    }}</span>
                </v-tooltip>
                </v-flex>
            </v-layout>

            <!-- Status -->
            <v-layout row wrap class="subheading pb-1">
                <v-flex xs6 class="grey--text text--darken-1">{{
                $t("screener.affiliation.list.table.status")
                }}</v-flex>
                <v-flex xs6>
                <v-chip
                    :color="affiliation.enabled ? 'success' : 'error'"
                    small
                    outline
                    dark
                    class="mx-0"
                    >{{ affiliation.enabled ? $t('screener.affiliation.status.enabled.title') : $t('screener.affiliation.status.disabled.title') }}</v-chip>
                </v-flex>
            </v-layout>

            <!-- Last reported at  -->
            <v-layout row wrap class="subheading pb-1">
                <v-flex xs6 class="grey--text text--darken-1">
                    {{$t('screener.affiliation.last_reported_at.title')}}
                </v-flex>
                <v-flex xs6>
                {{ fmtTime(affiliation.last_reported_at) }}
                </v-flex>
            </v-layout>

            <!-- Created at  -->
            <v-layout row wrap class="subheading pb-1">
                <v-flex xs6 class="grey--text text--darken-1">
                {{ $t("screener.affiliation.list.table.created_at") }}
                </v-flex>
                <v-flex xs6>
                {{ fmtTime(affiliation.created_at) }}
                </v-flex>
            </v-layout>
        </v-flex>

        <v-flex xs12 md6>
            <!-- Hits  -->
            <v-layout row wrap class="subheading pb-1">
                <v-flex xs6 class="grey--text text--darken-1"
                >{{ $t("screener.affiliation.list.table.hits") }}
                </v-flex>
                <v-flex xs6>
                    {{ affiliation.hits }}
                    <v-tooltip top color="white">
                        <template v-slot:activator="{on}">
                            <v-icon size="18" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <div class="greyDarken3--text body-1">
                            {{$t('screener.affiliation.hits.tooltip')}}
                        </div>
                    </v-tooltip>
                </v-flex>
            </v-layout>

            <!-- Conversions -->
            <v-layout row wrap class="subheading justify-center align-center">
                <v-flex xs6 class="grey--text text--darken-1">{{
                $t("screener.affiliation.list.table.conversions")
                }}</v-flex>
                <v-flex xs6>
                    {{ affiliation.conversions }}
                    <v-tooltip top color="white">
                        <template v-slot:activator="{on}">
                            <v-icon size="18" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <div class="greyDarken3--text body-1">
                           {{$t('screener.affiliation.conversions.tooltip')}}
                        </div>
                    </v-tooltip>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { utcToTz } from "@/helper";

export default {
    name:"AffiliationSummary",
    props:{
        affiliation:{
            type:Object,
            default:null
        }
    },
    computed:{
        ...mapGetters("company", {
            timezone: "getSelectedCompanyTimezone"
        })
    },
    methods:{
        copyToClipboard(item) {
            try {
                this.$copyText(item);
                this.$store.dispatch("app/showMessage", {
                    message: this.$t("screener.affiliation.code.copied.successfully"),
                    color: "success"
                });
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: "error"
                });
            }
        },
        fmtTime(input) {
            return utcToTz(input, this.timezone, "Do MMM YYYY, h:mm a");
        },
    }
}
</script>

<style>

</style>
